module.exports = __webpack_public_path__ + "img/jm03_xg.a8bbf1df.png";